/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/DailyChallenges/PyramidChallenge',[
    'lodash',
    'absolute/stringmanager',
    'absolute/textutils',
    'CardUI/IChallengeDefinition',
    'SolitaireShared/CardLogic/ChallengeConstants',
    'SolitaireShared/CardLogic/Card',
    'SolitaireShared/PyramidLogic/ChallengeAuthorities/AchieveScoreDailyPyramidAuthority',
    'SolitaireShared/PyramidLogic/ChallengeAuthorities/ClearBoardDailyPyramidAuthority',
    'SolitaireShared/PyramidLogic/ChallengeAuthorities/ClearRowsDailyPyramidAuthority',
    'SolitaireShared/PyramidLogic/ChallengeAuthorities/PlayCardDailyPyramidAuthority',
    'SolitaireShared/PyramidLogic/ChallengeAuthorities/PlayValuesDailyPyramidAuthority'
], function (_, _s, TextUtils, IChallengeDefinition, ChallengeConstants, Card, AchieveScoreDailyPyramidAuthority, ClearBoardsDailyPyramidAuthority, ClearRowsDailyPyramidAuthority, PlayCardDailyPyramidAuthority, PlayValuesDailyPyramidAuthority) {
    "use strict";

    var PyramidChallenge = function (challengeType, parameters, config) {
        this.initPyramidChallenge(challengeType, parameters, config);
    };

    var KeyMaxDeals = "MAXDEALS";

    PyramidChallenge.constructor = PyramidChallenge;
    PyramidChallenge.prototype = Object.create(IChallengeDefinition.prototype);

    PyramidChallenge.GoalType =
    {
        /// <summary>
        /// PARAMETERS: BoardsToClear
        /// </summary>
        ClearBoards: 0,

        /// <summary>
        /// PARAMETERS: ScoreRequired
        /// </summary>
        AchieveScore: 1,

        /// <summary>
        /// PARAMETERS: RowsRequired
        /// </summary>
        ClearRows: 2,

        /// <summary>
        /// PARAMETERS: CardToPlay
        /// </summary>
        PlayCard: 3,

        /// <summary>
        /// PARAMETERS: NumToPlay, ValueToPlay
        /// </summary>
        PlayValues: 4
    };

    PyramidChallenge.prototype.GoalType = PyramidChallenge.GoalType;


    PyramidChallenge.prototype.initPyramidChallenge = function (challengeType, parameters, config) {
        IChallengeDefinition.call(this, challengeType, parameters, config);

        if (!this.Parameters[KeyMaxDeals])
            this.Parameters[KeyMaxDeals] =  "3";


    };

    PyramidChallenge.prototype.ConstructAuthority = function () {
        var authority = PyramidChallenge.AuthorityTypes[this.ChallengeType](this.Parameters);
        this.SetupOptionsForAuthority(authority);

        var maxDeals = parseInt(this.Parameters[KeyMaxDeals]);
        if (!isNaN(maxDeals) && maxDeals > 0) {
            authority.MaxDeals = maxDeals;
        }

        return authority;
    };


    PyramidChallenge.prototype.GetGoalDescription = function ()
    {
        try
        {
            var maxDeals = this.Parameters[KeyMaxDeals];

            switch (this.ChallengeType)
            {
                case PyramidChallenge.GoalType.ClearBoards:
                    return _s(this.CompleteGoalLocString("DailyChallengeGoal_ClearBoards"),
                        [
                            this.Parameters[ChallengeConstants.KeyBoardsToClear],
                            maxDeals,
                            this.GetTimeFormat(this.AllowedTime)
                        ]
                    );
                case PyramidChallenge.GoalType.AchieveScore:
                    return _s(this.CompleteGoalLocString("DailyChallengeGoal_AchieveScore"),
                        [
                            TextUtils.formatInt(this.Parameters[ChallengeConstants.KeyScoreRequired]),
                            (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : maxDeals),
                            maxDeals
                        ]);
                case PyramidChallenge.GoalType.PlayValues:

                    var value = Card.GetLongValueName(this.Parameters[PlayValuesDailyPyramidAuthority.Key_ValueToPlay]);
                    var numToPlay = parseInt(this.Parameters[PlayValuesDailyPyramidAuthority.Key_NumToPlay]);

                    var valueKey = "Card_" + value;
                    if (!isNaN(numToPlay) && numToPlay > 1)
                    {
                        if (value.toUpperCase() == "SIX")
                            valueKey += "es";
                        else
                            valueKey += "s";
                    }
                    value = _s(valueKey);

                    return _s(this.CompleteGoalLocString("DailyChallengeGoal_ClearValuesFromBoard"),
                        [
                            numToPlay.toString(),
                            value,
                            maxDeals,
                            this.GetTimeFormat(this.AllowedTime)
                        ]
                    );
                case PyramidChallenge.GoalType.PlayCard:
                    var key = "DailyChallengeGoal_ClearValuesFromBoard";
                    if (this.AllowedTime > 0)
                        key += "_Time";
                    else
                        key += "_Moves";

                    var symbol = Card.GetSymbolStringFromShortName(this.Parameters[PlayCardDailyPyramidAuthority.KeyCardToPlay]);

                    var ret =_s(key,
                        [
                            symbol,
                            maxDeals,
                            this.GetTimeFormat(this.AllowedTime)
                        ]);

                    return ret;
                default:
                    return "";
            }
        }
        catch (e) {
                return "";
        }
    };

    PyramidChallenge.prototype.GetChallengeIconUrl = function () {
        return "Content/Icons/DailyChallenges/pyramid.png";
    };

    PyramidChallenge.prototype.GetModeName = function ()
    {
        return "Pyramid"; // TODO return SolitaireGamesMap.Titles[SolitaireGameMode.Pyramid];
    };

    PyramidChallenge.prototype.GetShortGoalDescription = function ()
    {
        switch (this.ChallengeType)
        {
        case PyramidChallenge.GoalType.ClearBoards:
            if(this.AllowedMoves > 0)
                return _s("Deals_Board_Challenge");

            if(this.AllowedTime > 0)
                return _s("Timed_Board_Challenge");

            return _s("Board_Challenge");

        case PyramidChallenge.GoalType.PlayCard:
        case PyramidChallenge.GoalType.PlayValues:
            if(this.AllowedMoves > 0)
                return _s("Moves_Card_Challenge");

            if(this.AllowedTime > 0)
                return _s("Timed_Card_Challenge");

            return _s("DCTile_Card_Challenge");

        case PyramidChallenge.GoalType.AchieveScore:
            if(this.AllowedMoves > 0)
                return _s("Moves_Score_Challenge");

            if(this.AllowedTime > 0)
                return _s("Timed_Score_Challenge");

            return _s("Score_Challenge");

        default:
            return "";
        }
    };


    PyramidChallenge.MakeClearBoardsAuthority = function (param) { return new ClearBoardsDailyPyramidAuthority(param); };
    PyramidChallenge.MakeScoreAuthority = function (param) { return new AchieveScoreDailyPyramidAuthority(param); };
    PyramidChallenge.MakeClearRowsAuthority = function (param) { return new ClearRowsDailyPyramidAuthority(param); };
    PyramidChallenge.MakePlayCardAuthority = function (param) { return new PlayCardDailyPyramidAuthority(param); };
    PyramidChallenge.MakePlayValuesAuthority = function (param) { return new PlayValuesDailyPyramidAuthority(param); };

    PyramidChallenge.AuthorityTypes =
        [
            PyramidChallenge.MakeClearBoardsAuthority,
            PyramidChallenge.MakeScoreAuthority,
            PyramidChallenge.MakeClearRowsAuthority,
            PyramidChallenge.MakePlayCardAuthority,
            PyramidChallenge.MakePlayValuesAuthority
        ];

    PyramidChallenge.FromDictionary = function (spec)
    {
        var challengeType = parseInt(spec.Data["CHDEF_ChallengeType"]);
        var parameters = {};


        _.forEach(spec.Data, function (value, key) {
            if (key.indexOf("PARAM_") == 0) {
                var nkey = key.substring(6);
                parameters[nkey] = value;
            }
        });


        var retval = new PyramidChallenge(challengeType, parameters, spec);
        retval.FromDictionaryInternal(spec.Data);

        return retval;
    };

    PyramidChallenge.FirstParameters =
    {
        "ClearBoards": "BoardsToClear",
        "AchieveScore": "ScoreRequired",
        "ClearRows": "RowsRequired",
        "PlayCard": "CardToPlay",
        "PlayValues": "NumberToPlay"
    };


    PyramidChallenge.SecondParameters =
    {
        "ClearBoards": null,
        "AchieveScore": null,
        "ClearRows": null,
        "PlayCard": null,
        "PlayValues": "ValueToPlay"
    };


    PyramidChallenge.prototype.CompleteGoalLocString = function (str)
    {
        var ret = str;

        var maxDeals = parseInt(this.Parameters[KeyMaxDeals]);

        if (this.AllowedTime > 0)
            ret += "_Time";
        if (!isNaN(maxDeals) && maxDeals > 0 && this.ChallengeType != PyramidChallenge.GoalType.AchieveScore)
            ret += "_Moves";

        var numToPlay = 0;
        var param = this.Parameters[PlayValuesDailyPyramidAuthority.Key_NumToPlay];
        numToPlay = parseInt(param);


        if (!isNaN(numToPlay) && numToPlay > 1)
        {
            ret += "_Multiple";
        }

        return ret;
    };

    return PyramidChallenge;

});

